import React from "react";
import InvoiceList from "../../components/event/InvoiceList";

const InvoicesPage = () => {
    return <InvoiceList/>
}

export default InvoicesPage;